import { render } from "./Sale_Details.vue?vue&type=template&id=5405346c&scoped=true"
import script from "./Sale_Details.vue?vue&type=script&lang=js"
export * from "./Sale_Details.vue?vue&type=script&lang=js"

import "./Sale_Details.vue?vue&type=style&index=0&id=5405346c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5405346c"]])

export default __exports__